import React, { useState, useMemo } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Pagination,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import { useGetAdminExercisesQuery } from "@/store/api/admin/exerciseApi";
import ExerciseAssignmentDialog from "@/components/admin/ExerciseAssignmentDialog";

const ExerciseList = () => {
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [assignmentDialogOpen, setAssignmentDialogOpen] = useState(false);
  const { data: exercisesData, isLoading: exercisesLoading } = useGetAdminExercisesQuery();

  const exercises = useMemo(() => exercisesData?.data || [], [exercisesData]);

  return exercisesLoading ? (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
      <CircularProgress />
    </Box>
  ) : (
    <Grid container spacing={2}>
      {exercises.map((exercise) => (
        <Grid item xs={12} md={6} lg={4} key={exercise._id}>
          <Card
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(0,0,0,0.08)",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  mb: 2,
                }}
              >
                <Typography variant="h6" fontWeight="600" sx={{ flex: 1 }}>
                  {exercise.title}
                </Typography>
              </Box>
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ 
                  mb: 2,
                  display: '-webkit-box',
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                dangerouslySetInnerHTML={{ __html: exercise.description }}
              />
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                <Chip 
                  label={exercise.isActive ? "Active" : "Inactive"} 
                  size="small" 
                  color={exercise.isActive ? "success" : "default"}
                  variant="outlined" 
                />
                <Chip
                  label={`${exercise.days?.length || 0} days`}
                  size="small"
                  variant="outlined"
                />
              </Box>
              <Button
                fullWidth
                variant="contained"
                startIcon={<GroupIcon />}
                onClick={() => {
                  setSelectedExercise(exercise);
                  setAssignmentDialogOpen(true);
                }}
                sx={{
                  background:
                    "linear-gradient(135deg, #FF9800 0%, #F57C00 100%)",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Manage Assignments
              </Button>
            </CardContent>
          </Card>
        </Grid>
      ))}
      
      {/* Exercise Assignment Dialog */}
      <ExerciseAssignmentDialog
        open={assignmentDialogOpen}
        onClose={() => {
          setAssignmentDialogOpen(false);
          setSelectedExercise(null);
        }}
        exercise={selectedExercise}
      />
    </Grid>
  );
};

export default ExerciseList;
